import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Grid,
  Stack,
  Button,
  LinearProgress,
  IconButton,
  Divider,
  Tab,
  Tabs,
} from "@mui/material";
import AuthContext from "../../store/AuthContext";
import { Edit, Delete } from "@mui/icons-material";
import EditCustomer from "./EditCustomer";
import DeleteCustomer from "./DeleteCustomer";
import RefreshComponent from "../../component/RefreshComponent";
import { Phone, Male } from "@mui/icons-material";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import axios from "axios";
import { BASE_URL } from "../../network/ApiEndPoints";
import { AddCustomer } from "./AddCustomer";
import ApiEndpoints from "../../network/ApiEndPoints";
// Main CustomerUser Component
export const CustomerUser = ({ users, refresh }) => {
  const [imageURLs, setImageURLs] = useState({});
  const [imageLoadStatus, setImageLoadStatus] = useState({}); // Track image load status
  const authCtx = useContext(AuthContext);
  const token = authCtx.token;
  const [tabValue, setTabValue] = useState("All");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const filteredUsers = users.filter((user) => {
    if (tabValue === "All") return true;
    return user.role === tabValue;
  });
  // Fetch profile images for all users

  // Check if there are no users
  if (!users?.length) {
    return (
      <Typography variant="h6" align="center">
        No user data available
      </Typography>
    );
  }

  return (
    <Box sx={{}}>
      <Grid container spacing={1.5}>
        {users?.map((user) => (
          <Grid item key={user.id} xs={12} sm={6} md={3} lg={2.4}>
            <Card
              sx={{
                padding: 1,
                textAlign: "center",
                borderRadius: 3,
                position: "relative",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                transition: "transform 0.2s ease-in-out",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    width: 90,
                    height: 90,
                    backgroundColor: "rgba(132, 61, 72, 0.3)", // Light red/pink
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  {/* Profile Image */}
                  {user.profile_image ? (
                    <img
                      alt={user.name}
                      src={user.profile_image}
                      style={{
                        width: 75,
                        height: 75,
                        borderRadius: "50%",
                      }}
                      onLoad={() => {
                        setImageLoadStatus((prevStatus) => ({
                          ...prevStatus,
                          [user.id]: true,
                        }));
                      }}
                    />
                  ) : user.name ? (
                    user.name.charAt(0).toUpperCase()
                  ) : (
                    "?"
                  )}

                  {/* Status Indicator */}
                  <Box
                    sx={{
                      width: 13,
                      height: 13,
                      borderRadius: "50%",
                      backgroundColor: user.status ? "green" : "red",
                      position: "absolute",
                      top: 70,
                      right: 8,
                      border: "2px solid white",
                    }}
                  />
                </Box>
              </Box>
              <Stack
                direction="row"
                sx={{
                  position: "absolute",
                  top: 4,
                  right: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <EditCustomer user={user} refresh={refresh} />
                <DeleteCustomer user={user} refresh={refresh} />
              </Stack>

              <CardContent>
                <Typography fontWeight="bold" sx={{ fontSize: "1.14rem" }}>
                  {user.name}
                </Typography>

                <Typography variant="body2" sx={{ color: "#808080", mt: 0.5 }}>
                  {user.email}
                </Typography>

                <Box
                  sx={{
                    background: "rgba(144, 238, 144, 0.4)",
                    padding: "4px 10px",
                    borderRadius: "8px",
                    display: "inline-block",
                    mt: 1,
                  }}
                >
                  <Typography variant="body2" color="green" fontWeight="bold">
                    {user.role}
                  </Typography>
                </Box>

                <Box sx={{ mt: 1.2 }}>
                  {/* <Typography variant="body2" color="gray">
                    65%
                  </Typography> */}

                  <Divider
                    sx={{
                      mt: 2,
                      borderWidth: 2,
                      width: "100%",
                      borderColor: "#000",
                    }}
                  />
                </Box>
                <Grid container spacing={1} sx={{ mt: 0.5 }}>
                  {/* Mobile Number */}
                  <Grid
                    item
                    xs={12}
                    lg={7.5}
                    display="flex"
                    alignItems="center"
                  >
                    <Box
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: "50%",
                        backgroundColor: "#F5E1DA",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0, // Prevents resizing
                      }}
                    >
                      <Phone sx={{ color: "brown", fontSize: 20 }} />
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        ml: 0.2,
                        color: "gray",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        flexGrow: 1,
                      }}
                    >
                      {user.mobile}
                    </Typography>
                  </Grid>

                  {/* Gender */}
                  <Grid
                    item
                    xs={12}
                    lg={4.5}
                    display="flex"
                    alignItems="center"
                  >
                    <Box
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: "50%",
                        backgroundColor: "#F5E1DA",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0, // Prevents resizing
                      }}
                    >
                      <PermIdentityIcon sx={{ color: "brown", fontSize: 20 }} />
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        ml: 0.4,
                        color: "gray",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        flexGrow: 1,
                      }}
                    >
                      {user.gender}
                    </Typography>
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    bottom: 8,
                    left: 12,
                    right: 12,
                    width: "calc(100% - 24px)", // Ensures proper spacing inside the card
                    mt: 4,
                  }}
                >
                  <Typography variant="caption" color="textSecondary">
                    Joined: {new Date(user.created_at).toLocaleDateString()}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
